import { ToastContainer, Bounce } from 'react-toastify';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

// Components
import Landing from './components/Landing/Landing';
import Home from './components/Food/Home';
import Order from './components/Order/Order';
import ProductView from './components/Product/ProductView';
import AppLayout from './components/Layout/AppLayout';

const App = () => {

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Landing />,
    },
    {
      path: "/home",
      element: <AppLayout />,
      children: [
        {
          path: '',
          element: <Home />
        }
      ]
    },
    {
      path: "/product/:id/:qty/:promoId",
      element: <AppLayout />,
      children: [
        {
          path: '',
          element: <ProductView />
        }
      ]
    },
    {
      path: "/product/:id/:qty",
      element: <AppLayout />,
      children: [
        {
          path: '',
          element: <ProductView />
        }
      ]
    },
    {
      path: "/order",
      element: <AppLayout />,
      children: [
        {
          path: '',
          element: <Order />
        }
      ]
    },
  ]);

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        closeButton={false}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
        theme="colored"
        transition={Bounce}
      />

      <RouterProvider router={router} />
    </>
  );
};

export default App;
